import React, { useEffect, useRef, useState } from 'react'
import MolGrid from '../../../components/Grid/MolGrid';
import CenterModel from '../../../components/ui/centerModel/CenterModel';
import { academicMemberTasklistTableConfig } from '../data/AcademicMemberTable.Data';
import { useGetAcadmicTaskListMutation } from '../../../app/services/Academic/AcademicTaskListApi';
import { useNavigate } from 'react-router-dom';
import { encryptAESID } from '../../../utils/Encryption';
import { useLazyDeleteMemberQuery } from '../../../app/services/Common/CommonApi';
import ToastService from '../../../services/toastService/ToastService';
import SwalAlert from '../../../services/swalService/SwalService';
import { getAuthProps } from '../../../lib/authenticationLibrary';

const AcademicMemberTable = ({ paginationReq }) => {
    const navigate = useNavigate();
    const molGridRef = useRef();
    const { confirm, error, success, confirmDelete } = SwalAlert();
    const [dataSource, setDataSource] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loginAdminId, setLoginAdminId] = useState("");
    const [paginationRequest, setPaginationRequest] = useState({
        pageNo: 1,
        pageSize: 10,
        endPage: 100,
        SearchText: "",
        gmapNumber: "",
        submissionStartDate: "",
        submissionEndDate: "",
        totalCount: 0,
        StatusId: null
    });

    const [memberTaskList,
        { isSuccess: isSuccess,
            isLoading: isLoading,
            data: memberTaskResponse },
    ] = useGetAcadmicTaskListMutation();

    const [deleteRecord, {
        data: deleteResponse,
        isSuccess: isDeleteSuccess,
        isLoading: isDeleteLoading,
    }] = useLazyDeleteMemberQuery()

    // useEffect(() => {
    //     memberTaskList(paginationReq)
    // }, [])

    useEffect(() => {
        let loginData = getAuthProps();
        setLoginAdminId(loginData.adminUserId);
        setDataSource([]);
        memberTaskList(paginationReq)
        setPaginationRequest(paginationReq);
    }, [paginationReq])

    useEffect(() => {
        if (!isLoading && isSuccess && memberTaskResponse) {
            setPaginationRequest({ ...paginationRequest, totalCount: memberTaskResponse.totalCount })
            setDataSource(memberTaskResponse.itemList)
        }
    }, [isLoading, isSuccess, memberTaskResponse]);

    useEffect(() => {
        if (!isDeleteLoading && isDeleteSuccess && deleteResponse) {
            ToastService.success("Delete Item successfully");
            memberTaskList(paginationReq)
        }
    }, [isDeleteLoading, isDeleteSuccess, deleteResponse])

    const handlePageChange = ({ pageNumber, pageSize }) => {
        memberTaskList({ ...paginationRequest, pageNo: pageNumber, pageSize: pageSize })
    }
    // Function to handle Edit click
    const handleViewClick = (memberID) => {
        navigate(`/academicMember/${encryptAESID(memberID)}`);
    }

    const handleCustomActionClick = (rowData, buttonName) => {
        if (buttonName === "Delete") {
            handleTableDelete(rowData?.academicMembersId)
        } else {
            handleViewClick(rowData?.academicMembersId)
        }
    };

    const handleTableDelete = (memberID) => {
        const request = {
            id: memberID,
            isCorporateMember: false,
            isAcademicMember: true,
            deletedBy: loginAdminId,
        }
        confirmDelete("Are you sure?", "Type 'delete' to confirm", "Delete", "Cancel")
            .then((confirmed) => {
                if (confirmed) {
                    deleteRecord(request);
                }
            });

    }

    const openModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const actionHandler = {
        "CUSTOM_ACTION_CLICK": handleCustomActionClick
    }

    return (
        <>
            <h1 className="account-info-title">
                Total :{paginationRequest.totalCount}
            </h1>
            <MolGrid
                ref={molGridRef}
                configuration={academicMemberTasklistTableConfig}
                dataSource={dataSource}
                allowPagination={true}
                isLoading={isLoading}
                pagination={paginationRequest}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
            />
            {isModalOpen &&
                <CenterModel
                    modelTitle={'Test'}
                    show={"test"}
                    handleClose={openModal}
                    onUpload={openModal}
                >
                    <h1>Hello</h1>
                </CenterModel>
            }
        </>
    )
}

export default AcademicMemberTable